import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneMapApiService } from './one-map-api.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [OneMapApiService],
})
export class OneMapApiModule {}
